/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress } from "@mui/material";
import { regular } from "cms/icons";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { DocumentCard } from "../../dialog/document-cover";
import SimpliCitySDK from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isEmpty } from "lodash";

const { faBoxArchive } = regular;

const DocumentEditArchivePanel = (props) => {
    const { token } = useAuth();
    const { handleArchive, loading } = props;
    const { selectedDocument, setIsArchiving, document, setSelectedDocEditTab } = useContext(DocumentEditContext);
    const [documentPlacments, setDocumentPlacements] = useState([]);
    const handleCancel = () => {
        setIsArchiving(false);
    };

    const handleViewDetails = () => {
        setIsArchiving(false);
        setSelectedDocEditTab(2);
    };

    useEffect(() => {
        const getDocumentPlacements = async () => {
            const guid = document?.guid || selectedDocument?.guid;
            if (guid) {
                const result = await SimpliCitySDK.documents.placements(token, guid);
                setDocumentPlacements(result?.placements || {});
            }
        };
        getDocumentPlacements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className="archive-section">
            <h2 className="sectionHeader">Archive document</h2>
            <p className="archive-confirmation">Please confirm you want to archive this document:</p>
            <div className="archive-image-card">
                <DocumentCard
                    displayWidth={64}
                    displayHeight={64}
                    fileExt={selectedDocument?.file_ext}
                    fontSize="4rem"
                />
                <div className="archive-image-info">
                    <strong>{selectedDocument?.file_name}</strong>
                    <a href={selectedDocument?.url} className="archive-image-link">
                        {selectedDocument?.file_name}
                    </a>
                </div>
            </div>
            <p>When archiving a document:</p>
            <ul className="archive-details">
                <li>Any existing links to the document will be broken</li>
                <li>The document will no longer be accessible via a public URL</li>
                <li>The document will no longer be searchable within primary digital asset areas.</li>
                <li>The document will be stored within a secondary document archive library</li>
            </ul>
            <div className="document-placements">
                {isEmpty(documentPlacments) ? (
                    "Currently, this document is not being used in any placements on the website and it is safe to archive it."
                ) : (
                    <div>
                    Currently, this document is being used in{" "}
                        <strong>{documentPlacments?.length} placement(s)</strong> on the website.
                    It is recommended that you manually remove or replace any existing
                    placements before proceeding.{" "}
                        <span className="doc-view-detail-cta" onClick={handleViewDetails}>
                        View details
                        </span>
                    </div>
                )}
            </div>
            <div className="simplicity-image-archive-window-footer">
                <Button variant="contained" color="primary" onClick={handleCancel} className="cancel-btn">
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleArchive}
                    className="archive-btn"
                    startIcon={
                        loading ? (
                            <CircularProgress size="22px" color="inherit" />
                        ) : (
                            <FontAwesomeIcon icon={faBoxArchive} style={{ color: "#0E7490" }} />
                        )
                    }
                    disabled={loading}
                >
                    <div>Archive</div>
                </Button>
            </div>
        </div>
    );
};
export { DocumentEditArchivePanel };
